<script setup>
import { useLayout } from '@/layout/composables/layout';

const { isDarkTheme } = useLayout();
</script>

<template>
    <div class="layout-footer">
        <div class="footer-logo-container">
            <img :src="`/layout/images/lfi.png`" alt="poseidon-layout" />
            <span class="footer-app-name">LFI</span>
        </div>
        <span class="footer-copyright">&#169; Law Firm Intelligence, Inc. - 2025</span>
    </div>
</template>
